import React from 'react';
import Icon from '../../common/Icons';

export default function NurseQuickAccessCard({ icon, title, hint, badge, accent = false, onClick }) {
  return (
    <button
      type="button"
      className={`nr-quick-card${accent ? ' nr-quick-card--accent' : ''}`}
      onClick={onClick}
    >
      <span className="nr-quick-card__icon" aria-hidden>
        <Icon name={icon} size={22} />
      </span>
      <span className="nr-quick-card__body">
        <span className="nr-quick-card__title-row">
          <span className="nr-quick-card__title">{title}</span>
          {badge != null && Number(badge) > 0 ? (
            <span className="nr-quick-card__badge">{badge}</span>
          ) : null}
        </span>
        {hint ? <span className="nr-quick-card__hint">{hint}</span> : null}
      </span>
      <span className="nr-quick-card__chevron" aria-hidden>
        →
      </span>
    </button>
  );
}
